import { render, staticRenderFns } from "./CommonRouterView.vue?vue&type=template&id=cebedcda&scoped=true&"
import script from "./CommonRouterView.vue?vue&type=script&lang=js&"
export * from "./CommonRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebedcda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cebedcda')) {
      api.createRecord('cebedcda', component.options)
    } else {
      api.reload('cebedcda', component.options)
    }
    module.hot.accept("./CommonRouterView.vue?vue&type=template&id=cebedcda&scoped=true&", function () {
      api.rerender('cebedcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonRouterView.vue"
export default component.exports